import React, { useState, useEffect } from 'react';
import { useCommon } from '../CommonServiceProvider';
import { useAuth } from '../../auth/AutoContextProvider';

const TemplateUploader = () => {
  const [uploadStatus, setUploadStatus] = useState('');
  const [_, { sso, getCookie, getFinalGuestToken }] = useAuth();
  const [{ uploadEmailTemplate, refreshLimitToken }] = useCommon();
  const [htmlContent, setHtmlContent] = useState('');
  const refresh = getCookie('tkn-ath-rfrsh')



  useEffect(() => {
    const fetchTemplateContent = async () => {
      try {
        const response = await fetch('/email/buildmii-send-email-template.html');
        const content = await response.text();
        setHtmlContent(content);
      } catch (error) {
        console.error('Error fetching template content:', error);
      }
    };

    fetchTemplateContent();
  }, []);

  const handleUpload = async () => {
    const payload = {
      name: 'Worldify-Welcome-Email',
      subject: `Here is your job description`,
      html: htmlContent,
    };

    try {
        const response = await uploadEmailTemplate(payload);
        if (response?.status === 200) {
            setUploadStatus('Template uploaded successfully.');
            if (response?.headers['rate-limit-token'] && response?.headers['rate-limit-refresh-token']) {
                sso(response?.headers['rate-limit-token'], response?.headers['rate-limit-refresh-token']);
            }
        } else {
            const errorText = await response.text();
            refreshLimitToken(refresh)
            setUploadStatus(`Error uploading the template: ${errorText}`);
        }
    } catch (error) {
        refreshLimitToken(refresh)
        setUploadStatus(`Error uploading the template: ${error.message}`);
    }
  };

  return (
    <button
      className="bg-white-500 hover:bg-gray-300 border-[2px] border-themeColor-100 text-themeColor-200 font-bold py-2 px-4 rounded-full"
      onClick={handleUpload}
    >
      Create/Upload BuildMii Email Template
    </button>
  );
};

export default TemplateUploader;
